import React from 'react';

const TestBooking = () => {
  // Force alert to show immediately
  React.useEffect(() => {
    alert('🚨 TEST BOOKING COMPONENT LOADED! 🚨');
    console.log('🚨 TEST BOOKING COMPONENT RENDERED! 🚨');
  }, []);

  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#1a1a1a', 
      color: 'white', 
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ color: '#ff6b6b', fontSize: '2rem', marginBottom: '20px' }}>
        🚨 TEST BOOKING PAGE - CACHE CLEARED! 🚨
      </h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
        If you can see this page, the React app is working!
      </p>
      <div style={{ 
        backgroundColor: '#2d2d2d', 
        padding: '20px', 
        borderRadius: '8px',
        border: '2px solid #ff6b6b'
      }}>
        <h2 style={{ color: '#4ecdc4', marginBottom: '10px' }}>Test Information:</h2>
        <p>✅ React component loaded successfully</p>
        <p>✅ Alert popup should have appeared</p>
        <p>✅ Console should show debug message</p>
        <p>✅ Current time: {new Date().toLocaleString()}</p>
      </div>
    </div>
  );
};

export default TestBooking;

